import React from 'react'
import { INLINES } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import './Info.scss'
import Header from '../components/Header.js';
import { motion, AnimatePresence } from 'framer-motion';
import { Helmet } from 'react-helmet';


const Imprint = ({ imprint, buttons }) => {

    const renderOptions = {
        renderText: text =>
            text.split('\n').reduce((children, textSegment, index) => {
                return [...children, index > 0 && <br key={index} />, textSegment];
            }, []),
        renderNode: {
            [INLINES.HYPERLINK]: (node, children) => {
                const { uri } = node.data;
                return (
                    <a href={uri} target="_blank" rel="noopener noreferrer">
                        {children}
                    </a>
                );
            },
        },
    };

    return (

        <AnimatePresence mode="wait">
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 1 }}
            >
                <Helmet>
                    <title>Imprint • Alex de Brabant</title>
                    <meta name="description" content="Alex de Brabant is a Canadian artist and photographer based in Berlin, working at the intersection of art, culture, design, and ecology." />
                    <link rel="canonical" href="https://alexdebrabant.com/imprint" />
                    <meta property="og:title" content="Imprint • Alex de Brabant" />
                    <meta property="og:description" content="Alex de Brabant is a Canadian artist and photographer based in Berlin, working at the intersection of art, culture, design, and ecology." />
                    <meta property="og:type" content="website" />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content="Imprint • Alex de Brabant" />
                    <meta name="twitter:description" content="Alex de Brabant is a Canadian artist and photographer based in Berlin, working at the intersection of art, culture, design, and ecology." />
                </Helmet>

                <Header pageTitle="Imprint" buttons={buttons} />

                <div className="info-container" >
                    {imprint && imprint.imprintText ? (
                        <div className="info-text">
                            {documentToReactComponents(imprint.imprintText, renderOptions)}
                        </div>
                    ) : (
                        <div>Loading imprint...</div>
                    )}
                </div>
            </motion.div>
        </AnimatePresence>
    )
}

export default Imprint